import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useCallback } from 'react';

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '明星黑料', path: '/category/mingxing-heiliao' },
    { name: '翻车现场', path: '/category/fanche-xianchang' },
    { name: '网红黑料', path: '/category/wanghong-heiliao' },
    { name: '争议事件', path: '/category/zhengyi-shijian' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <header>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/60'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl text-foreground-50 group-hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
                黑料视频
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-md text-sm whitespace-nowrap transition-colors duration-200 ${
                    location.pathname === link.path
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/70'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            <div className="hidden md:flex items-center gap-3">
              <button
                className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-400 hover:text-foreground-100 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
            </div>

            <button
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-300 hover:text-foreground-50 transition-colors duration-200 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ${
            isMobileMenuOpen ? 'max-h-96 border-t border-background-300/60 bg-background-100/95 backdrop-blur-md' : 'max-h-0'
          }`}
        >
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-3 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors duration-200 ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-50 hover:bg-background-200/70'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </nav>
    </header>
  );
}